export default __webpack_public_path__ + "static/media/cnvinbox-white.101a3df4.png";